import { call, put, select } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  set as setSearch
} from 'store/redux/search'
import camelCaseKeys from 'utils/camelCaseKeys'
import { AuthError } from '@kanbo/api'

export default function * fetchSearchDocuments (action) {
  const { refresh, boardId, limit } = action.payload

  if (refresh) {
    yield put(setSearch({
      documents: [],
      documentsCursor: null,
      documentsTotalCount: null,
      documentsLoadedAll: false,
      documentsLoading: true
    }))
  } else {
    yield put(setSearch({
      documentsLoading: true
    }))
  }

  const state = yield select()

  const { query, limitToBoard, refiners, documents, documentsCursor, documentsSort } = state.kanbo.search

  try {
    const { Results, Cursor, Refiners, SortOptions, TotalRows } = yield call(apiGetData, 'SearchAllDocumentSourceFiles', {
      query,
      cursor: documentsCursor,
      limit,
      sort: documentsSort,
      boardId: (boardId && limitToBoard) ? boardId : null,
      refiners: Object.keys(refiners.documents).map(key => ({
        id: key,
        ...refiners.documents[key]
      })),
    })

    yield put(setSearch({
      documents: [
        ...documents,
        ...Results.map(Document => ({
          fullUrl: Document.FullUrl,
          lastModificationTimestamp: Document.LastModificationTimestamp,
          name: Document.Filename,
          size: Document.Size,
          sourceId: Document.SourceId,
          url: Document.Url,
          parentUrl: Document.ParentUrl,
          highlight: Document.Highlight && {
            html: Document.Highlight.HighlightHtml,
            type: Document.Highlight.Type
          },
          thumbnailUrl: Document.ThumbnailUrl,
          actions: Document.Actions ? Document.Actions.map(camelCaseKeys) : [],
          loadActions: Document.LoadActions,
        }))
      ],
      documentsCursor: Cursor,
      documentsRefiners: Refiners ? camelCaseKeys(Refiners) : [],
      documentsSortOptions: SortOptions ? camelCaseKeys(SortOptions) : [],
      documentsTotalCount: TotalRows,
      documentsLoadedAll: !Cursor,
      documentsLoading: false
    }))
  } catch (error) {
    if (error instanceof AuthError) {
      yield put(setSearch({
        documentsLoadedAll: true,
        documentsLoading: false,
      }))
    } else if (error.code === 542) { // Service failure (400): BadRequest
      yield put(setSearch({
        documentsLoadedAll: true,
        documentsLoading: false,
        documentsError: error,
      }))
    } else {
      yield put(setSearch({
        documentsLoading: false
      }))

      throw error
    }
  }
}
